module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn new_orders"
  }, [_c('filters', {
    attrs: {
      "scope": _vm.filtersScope
    }
  }), _vm._v(" "), _c('operators-conversion-tabs'), _vm._v(" "), _c('div', {
    staticClass: "container__table",
    staticStyle: {
      "overflow": "hidden",
      "width": "100%"
    }
  }, [_c('div', {
    directives: [{
      name: "hammer",
      rawName: "v-hammer:pan",
      value: (_vm.onSwipe),
      expression: "onSwipe",
      arg: "pan"
    }],
    staticStyle: {
      "display": "flex",
      "flex-wrap": "nowrap",
      "width": "100%"
    },
    style: ({
      'transform': 'translate3d(' + _vm.x + 'px, 0px, 0px)'
    }),
    attrs: {
      "id": "swipe"
    }
  }, _vm._l((_vm.rows), function(dataWeek, indexWeek) {
    return _c('div', {
      staticClass: "statistic-wrap"
    }, [_c('div', {
      staticClass: "card statistic-table"
    }, [_c('div', {
      staticClass: "card-header"
    }, [_vm._v("\n              " + _vm._s(_vm.getWeekDaysByWeekNumber(indexWeek)) + "\n              "), _vm._m(0, true)]), _vm._v(" "), _c('div', {
      staticClass: "card-block"
    }, [_c('table', {
      staticClass: "table"
    }, [_c('thead', [(_vm.headColumns) ? _c('tr', _vm._l((_vm.headColumns), function(col) {
      return _c('th', {
        style: ({
          background: col.color
        }),
        attrs: {
          "colspan": col.colspan
        }
      }, [_vm._v(_vm._s(col.label))])
    })) : _vm._e()]), _vm._v(" "), _c('tbody', _vm._l((dataWeek), function(row) {
      return _c('tr', [_c('td', {
        staticStyle: {
          "background": "#e0e0e0"
        }
      }, [_vm._v(_vm._s(_vm.operatorsReturn(row.operator_id)))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "background": "#81c784"
        }
      }, [_vm._v(_vm._s(row.approved))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.total > 0 ? ((row.approved / row.total) * 100).toFixed(1) + '%' : '0%'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s((row.total - row.paid) > 0 ? ((row.approved / (row.total - row.paid)) * 100).toFixed(1) + '%' : '0%'))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "background": "#b9f6ca"
        }
      }, [_vm._v(_vm._s(row.paid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.approved > 0 ? ((row.paid / row.approved) * 100).toFixed(1) + '%' : '0%'))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "background": "#bae0ff",
          "white-space": "nowrap"
        }
      }, [_vm._v(_vm._s(row.total_buyout_usd > 0 ? '$ ' + (row.total_buyout_usd / row.paid).toFixed(2) : '$ 0.00'))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "background": "#bae0ff",
          "white-space": "nowrap"
        }
      }, [_vm._v(_vm._s(row.local_currency.split(',').length === 1 ? ((row.total_buyout_local) + " " + (_vm.localCurrency(row.local_currency))) : '-'))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "background": "#ffd96a",
          "white-space": "nowrap"
        }
      }, [_vm._v(_vm._s(row.approved > 0 ? '$ ' + ((row.total_buyout_usd * ((row.paid / row.approved) * 100)) / 100).toFixed(2) : '$ 0.00'))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "background": "#60b3f6",
          "white-space": "nowrap"
        }
      }, [_vm._v(_vm._s(row.total_buyout_usd > 0 ? '$ ' + (row.paid * (row.total_buyout_usd / row.paid)).toFixed(2) : '$ 0.00'))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "background": "#8fbc8f",
          "white-space": "nowrap"
        }
      }, [_vm._v(_vm._s(_vm.approvedFromValid(row.approved, row.total, row.spam)))])])
    })), _vm._v(" "), _c('tfoot', _vm._l((dataWeek.total), function(row) {
      return _c('tr', [_c('th', {
        staticStyle: {
          "background": "#e0e0e0"
        }
      }, [_vm._v(_vm._s(row.label))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "background": "#81c784"
        }
      }, [_vm._v(_vm._s(row.approved))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.total > 0 ? ((row.approved / row.total) * 100).toFixed(1) + '%' : '0%'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.total > 0 ? ((row.approved / (row.total - row.paid)) * 100).toFixed(1) + '%' : '0%'))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "background": "#b9f6ca"
        }
      }, [_vm._v(_vm._s(row.paid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.approved > 0 ? ((row.paid / row.approved) * 100).toFixed(1) + '%' : '0%'))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "background": "#bae0ff"
        }
      }, [_vm._v(_vm._s(row.total_bill))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "background": "#bae0ff"
        }
      }, [_vm._v(_vm._s(row.total_local))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "background": "#ffd96a"
        }
      }, [_vm._v(_vm._s('$ ' + row.total_revenue))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "background": "#60b3f6",
          "white-space": "nowrap"
        }
      }, [_vm._v(_vm._s('$ ' + row.total_all_average))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "background": "#8fbc8f",
          "white-space": "nowrap"
        }
      }, [_vm._v(_vm._s('$ ' + row.approvedFromValid))])])
    }))], 1)])])])
  }))])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-actions"
  }, [_c('button', {
    staticClass: "btn-close"
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0036ce6a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/statistics/operators/conversions/NewOrdersWeek.vue
// module id = 499
// module chunks = 0